import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-variable-allowdeduction',
  templateUrl: './variable-allowdeduction.component.html',
  styleUrls: ['./variable-allowdeduction.component.css']
})
export class VariableAllowdeductionComponent implements OnInit {

  title="Variable Allowance/Deduction Data ";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/variable-allowance-deduction-details/variable-allowdeduction/variable-allowdeduction.component.ts